<template>
    <div>
      <canvas ref="chart"></canvas>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      labels: {
        type: Array,
        default: () => [],
      },
      datasets: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        chartInstance: null,
        datasetColors: ["#8B0000", "#0000CD", "#228B22"], // Dark Red, Medium Blue, Forest Green
      };
    },
    watch: {
      labels: {
        handler() {
          this.updateChart();
        },
        deep: true,
      },
      datasets: {
        handler() {
          this.updateChart();
        },
        deep: true,
      },
    },
    mounted() {
      this.createChart();
    },
    methods: {
      createChart() {
        if (!this.labels.length || !this.datasets.length) return; // Prevents empty chart error
  
        this.chartInstance = new Chart(this.$refs.chart, {
          type: "radar",
          data: {
            labels: this.labels,
            datasets: this.datasets.map((dataset, index) => ({
              ...dataset,
              backgroundColor: "transparent",
              borderColor: this.datasetColors[index % this.datasetColors.length],
              pointBackgroundColor: this.datasetColors[index % this.datasetColors.length],
              borderWidth: 2,
            })),
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              r: {
                suggestedMin: 0,
                suggestedMax: 5,
                ticks: { stepSize: 1.0, font: { size: 14, weight: "bold" }, color: "#000" },
                pointLabels: { font: { size: 16, weight: "bold" } },
                grid: { color: "rgba(0, 0, 0, 0.2)", lineWidth: 1.5 },
              },
            },
            plugins: {
              legend: { display: true, position: "bottom", labels: { font: { size: 14 }, boxWidth: 15, padding: 10 } },
            },
          },
        });
      },
      updateChart() {
        if (!this.chartInstance) {
          this.createChart();
          return;
        }
  
        //console.log("Updating chart with new data:", JSON.stringify(this.datasets));
  
        // ✅ Update labels and datasets dynamically
        this.chartInstance.data.labels = [...this.labels];
        this.chartInstance.data.datasets = this.datasets.map((dataset, index) => ({
          ...dataset,
          backgroundColor: "transparent",
          borderColor: this.datasetColors[index % this.datasetColors.length],
          pointBackgroundColor: this.datasetColors[index % this.datasetColors.length],
          borderWidth: 2,
        }));
  
        this.chartInstance.update(); // ✅ Update chart without destroying
      },
    },
  };
  </script>
  
  <style>
  canvas {
      max-width: 80vh;
      max-height: 40vh;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/company/kirc/components/ChartJSRadar.vue